import { mapState } from 'vuex';

import {
  getImageWithSize,
  decode,
  formatPrice,
  getStarsHTML,
} from 'utils/general';

/**
 * This component is used throughout the site,
 * in product carousels and on the PLP page.
 */
export default {
  components: {
    'vue-image': () => import('../vue-image/vue-image.vue'),
    'vue-image-v2': () => import('../vue-image-v2/vue-image-v2.vue'),
  },
  props: ['collection', 'featuredOption', 'decode'],
  /**
   * Data can come via a JSON string that needs to be
   * decoded, or via an javascript object, passed by a
   * parent component or a Vuex store.
   */
  data() {
    let collection;

    if (!!this.decode && this.collection) {
      collection = JSON.parse(decode(this.collection));
    } else {
      collection = this.collection || {
        title: '',
        price: '',
        featuredImage: '',
        variants: [],
        optionNames: [],
        optionsWithValues: {},
      };
    }

    // collection = cleanseProductJson(collection)

    return {
      collectionParsed: collection,
      activeOption: '',
      selectedColor: false,
      optionMap: { Size: [] },
    };
  },
  mounted() {},
  computed: {
    ...mapState('global'),
    featured() {
      return this.collectionParsed.products.find(
        (product) => product.variants[0].option1 === this.featuredOption,
      );
    },
    itemCount() {
      return `${this.collectionParsed.products.length} shades`;
    },
    imageSrc() {
      return getImageWithSize(this.featured.featuredImage);
    },
    link() {
      return `${Shopify.routes.root}products/${this.featured.handle}`;
    },
    badges() {
      const badges = this.featured.tags
        .filter((tag) => {
          return tag.includes('badge:');
        })
        .map((badge) => badge.replace('badge:', ''));

      if (!badges.length) return false;

      return badges.join(' + ');
    },
    formattedPrice() {
      return formatPrice(this.featured.price);
    },
    title() {
      return this.featured.title.split(window.__GLOBAL__.productDelimiter)[0];
    },
    variantTitle() {
      return this.featured.title.split(window.__GLOBAL__.productDelimiter)[1];
    },
  },
};
